// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2WxA4","location":"Header_location__Ir57v"};